import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100",
  height: "100"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g fill=\"#022b36\" stroke=\"#f59600\" stroke-width=\"2\"><circle cx=\"50\" cy=\"50\" r=\"50\" stroke=\"none\"></circle><circle cx=\"50\" cy=\"50\" r=\"49\" fill=\"none\"></circle><text fill=\"#f59600\" font-family=\"RakutenSansUI-Bold, Rakuten Sans UI\" font-size=\"40\" font-weight=\"700\"><tspan x=\"30.3\" y=\"60\"> Q</tspan></text></g>", 1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };